import React, { useEffect, useState } from 'react'
import Button from '@material-ui/core/Button'
import { useHistory } from 'react-router-dom'

//helpers
import getParams from '../../../../__helpers/params'

function Search() {
    const history = useHistory()

    const [state, setState] = useState({
        value: ''
    })

    const handleSubmit = e => {
        e.preventDefault()

        const val = document.querySelector('input[type="search"]').value

        history.push(`/search?value=${val}`)
    }

    const handleChange = e => {
        const value = e.target.value

        setState(prev => ({
            ...prev,
            value
        }))
    }

    useEffect(() => {
        setState(prev => ({
            ...prev,
            value: getParams('value') || ''
        }))
    }, [history.location])
    

    return (
        <div className="search-bar-holder">
            <form className="search-bar" id="search" onSubmit={handleSubmit} autoComplete="off">
                <input
                    type="search"
                    name="search"
                    onChange={handleChange}
                    value={state.value}
                />
                <Button type="submit" form="search">
                    Търсене
                </Button>
            </form>
        </div>
    )
}

export default Search